<mat-dialog-content>
    <form [formGroup]="valorCredimorarEditForm" (ngSubmit)="onSubmit()" class="i2Tech-form">
        <div class="mb-3">
            <app-c-input class="form-control"
                formControlName="valor"
                label="Valor:"
                alignItem="flex-start"
                inputMask="separator.2"
                [required]="true"
                [currencyMask]="true"
                [readonly]="false"></app-c-input>

            <div *ngIf="hasError('valor', 'required')" class="form-error">
                O campo <strong>Valor</strong> é obrigatório.
            </div>
        </div>

        <div class="horizontal-container">
            <button type="button" class="ui-btn ui-btn--secondary" style="width: 45%;"
                (click)="closeDialogCommissionEdit()">
                Cancelar
            </button>
            <button type="submit" class="ui-btn ui-btn--primary" style="width: 50%;">Salvar Alterações</button>
        </div>
    </form>
</mat-dialog-content>